import { Checkbox, Group } from "@mantine/core";

import { TextWrapper } from "@/components/TextWrapper";

import { FormCheckboxSectionHeaderProps } from "../interfaces/form-components";

export function FormCheckboxSectionHeader({
  title,
  allChecked,
  someChecked,
  disabled = false,
  showAllCheckbox = true,
  onToggleAll,
}: FormCheckboxSectionHeaderProps) {
  return (
    <Group justify="space-between">
      <TextWrapper fz="h3" c="gray.6">
        {title}
      </TextWrapper>
      {showAllCheckbox && (
        <Checkbox
          c="gray.6"
          label="Select all"
          disabled={disabled}
          checked={allChecked}
          onChange={onToggleAll}
          indeterminate={someChecked}
        />
      )}
    </Group>
  );
}
